"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_tooltip_1 = require("@hotelplan/components.common.tooltip");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const InfoNotificationWrapper = styled_components_1.default.div({
    position: 'relative',
});
const TooltipWrapper = styled_components_1.default.div(({ theme }) => theme.travelRooms.tooltipWrapper);
function TravelRoomsInfoNotification({ text, }) {
    const [showNotification, show, close] = (0, libs_hooks_react_1.useToggleState)(false);
    const notificationTooltipRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(InfoNotificationWrapper, null,
        react_1.default.createElement(components_common_icon_1.Icon, { name: "info", onMouseEnter: show, onMouseLeave: close }),
        showNotification ? (react_1.default.createElement(TooltipWrapper, { onMouseEnter: show, onMouseLeave: close },
            react_1.default.createElement(components_common_tooltip_1.Tooltip, { tooltipElRef: notificationTooltipRef }, text))) : null));
}
exports.default = TravelRoomsInfoNotification;
//# sourceMappingURL=TravelRoomsInfoNotification.js.map